var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container-content"
  }, [_c('div', {
    staticClass: "bubble"
  }, [_c('div', {
    staticClass: "bubble-title"
  }, [_vm._v(_vm._s(_vm.$t('common.congratulations')))]), _c('div', {
    staticClass: "bubble-text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('self.employed.status.confirmed.successfully'))
    }
  }), _c('div', {
    staticClass: "bubble-button"
  }, [_c('button', {
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.handleSubmit($event);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.proceed')) + " ")])])]), _vm.isBetaTest ? _c('div', {
    staticClass: "change-theme"
  }, [_c('div', {
    staticClass: "change-theme-button"
  }, [_c('button', {
    on: {
      "click": _vm.handleChangeTheme
    }
  }, [_c('div', {
    staticClass: "change-theme-icon"
  })])]), _c('div', {
    staticClass: "change-theme-text"
  }, [_vm._v(" " + _vm._s(_vm.$t('try.light.interface.theme')) + " ")])]) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }